@if (total > 0) {
  <div class="pagination-controls">
    <span class="pg-count">
      <strong>{{ total }} </strong>
      @if (total === 1) {
        {{ 'GUI.pagination_controls.labels.result' | translate }}
      } @else {
        {{ 'GUI.pagination_controls.labels.results' | translate }}
      }
    </span>
    @if (totalPages > 1) {
      <div class="pg-nav">
        <button
          class="flip-page"
          (click)="prev.emit()"
          [disabled]="page === 1"
          aria-label="Previous page"
          matTooltipPosition="before"
          matTooltip="{{ 'GUI.pagination_controls.tooltips.go_to_previous_page' | translate }}"
        >
          <img class="pg-ico" src="assets/icons/chevron-left.svg" alt="" aria-hidden="true" />
        </button>
        <span class="pg-label">
          {{ 'GUI.pagination_controls.labels.page' | translate }} {{ page }} /
          {{ totalPages }}
        </span>
        <button
          class="flip-page"
          (click)="next.emit()"
          [disabled]="page >= totalPages"
          aria-label="Next page"
          matTooltipPosition="after"
          matTooltip="{{ 'GUI.pagination_controls.tooltips.go_to_next_page' | translate }}"
        >
          <img class="pg-ico" src="assets/icons/chevron-right.svg" alt="" aria-hidden="true" />
        </button>
      </div>
    }
  </div>
}
